import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { UnarchiveInboundEmailMutation } from '@/gql/graphql';

const UNARCHIVE_INBOUND_EMAIL_MUTATION = graphql(`
  mutation UnarchiveInboundEmail($inboundEmailId: ID!) {
    unarchiveInboundEmail(inboundEmailId: $inboundEmailId) {
      id
      status
    }
  }
`);

const useUnarchiveInboundEmail = (
  options?: UseMutationOptions<
    UnarchiveInboundEmailMutation,
    unknown,
    { inboundEmailId: string }
  >
) => {
  return useMutation({
    mutationFn: ({ inboundEmailId }) => {
      return gqlClient.request(UNARCHIVE_INBOUND_EMAIL_MUTATION, {
        inboundEmailId,
      });
    },
    ...options,
  });
};

export default useUnarchiveInboundEmail;
